import { render, staticRenderFns } from "./TransactionWindow.vue?vue&type=template&id=1f3b8798"
import script from "./TransactionWindow.vue?vue&type=script&lang=js"
export * from "./TransactionWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports